// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSiHaDocumentationByShareIdRequestModel from '../../model/get-si-ha-documentation-by-share-id-request-model';
import GetSiHaDocumentationByShareIdRequestDTO from '../dto/get-si-ha-documentation-by-share-id-request-dto';
import dtoSchema from '../schemas/get-si-ha-documentation-by-share-id-request-schema';

export default abstract class GetSiHaDocumentationByShareIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSiHaDocumentationByShareIdRequestDTO>) {
    super();
    if (data) {
      this.shareId = data.shareId;
    }
  }
  /**
  * @type {uuid}
  */
  shareId?: string;

  static toModel(dto: DeepPartial<GetSiHaDocumentationByShareIdRequestDTO>): GetSiHaDocumentationByShareIdRequestModel;
  static toModel(dto: DeepPartial<GetSiHaDocumentationByShareIdRequestDTO> | undefined | null): GetSiHaDocumentationByShareIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSiHaDocumentationByShareIdRequestDTO> | undefined | null): GetSiHaDocumentationByShareIdRequestModel | undefined {
    return dto ? new GetSiHaDocumentationByShareIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSiHaDocumentationByShareIdRequestModel> | GetSiHaDocumentationByShareIdRequestModel): GetSiHaDocumentationByShareIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      shareId: unwrapped.shareId,
    } as GetSiHaDocumentationByShareIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSiHaDocumentationByShareIdRequestModel, can not map to GetSiHaDocumentationByShareIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
